import { Injectable } from '@angular/core';
import {BaseService} from "../base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {catchError, tap} from "rxjs/operators";
import {FileResResponseModel} from "../../models/document/file-res-response.model";
import {DocumentResponse} from "../../models/document/documentResponse";

@Injectable()
export class DocumentService  extends BaseService<any>{

  constructor(public httpClient: HttpClient) {
    super("document", httpClient)
  }

  getDoc(reference): Observable<any> {
    let uri = new URL(environment.baseUrl + '/document/getDoc').updateQueryParam({
      reference
    })
    // @ts-ignore
    return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders(), responseType: 'blob', observe: 'body' })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }

  upload(file: File, entityId: number): Observable<FileResResponseModel> {

    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('contentType',file.type)

    let uri = new URL(environment.baseUrl + '/document/upload').updateQueryParam({ entityId })
    return this.httpClient.post<FileResResponseModel>(uri.toString(), formData, { withCredentials: false, headers: this.httpHeaders() });
  }

  getDocuments(entityId): Observable<DocumentResponse[]> {
    let uri = new URL(environment.baseUrl + '/document/getDocs').updateQueryParam({
      entityId
    })
    // @ts-ignore
    return this.httpClient.get<DocumentResponse[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }


}
